import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'
const {
  SYSTEM_APP_NAME,
  SYSTEM_PRO_PUBLIC_PATH,
  SYSTEM_ACTIVE_RULE,
  SYSTEM_DEV_PORT,
  SYSTEM_DEV_PUBLIC_PATH,
  HALL_ACTIVE_RULE,
  // eslint-disable-next-line @typescript-eslint/no-var-requires
} = require('../../../../micro/config.js')
import { useLoadingStore } from '@/store/loading'
import pinia from '@/store'
import { useUserStore } from '@/store/user'
import { useAppStore } from '@/store/app'
import { useTokenStore } from '@/store/token'
import { useReuseTabStore } from '@/store/reuse-tab'

Vue.use(VueRouter)
interface IMeta {
  title?: string // 标题
  backgroundColor?: string
  dismiss?: boolean
  middleware?: string // 要运行的中间件名称，多个中间件使用 ',' 进行拼接，例如 '中间件A,中间件B,中间件C'
  keepAlive?: boolean // 路由页面是要需要 keepAlive 特性
  redirect?: string // 页面是否要重定向至某一个页面
}
const originalPush = VueRouter.prototype.push
//push
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return originalPush.call(this, location).catch((err) => err)
}
const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/hall',
  },
  // {
  //   path: '/login',
  //   component: () => import('@/views/MicroApp.vue'),
  //   meta: {
  //     appName: SYSTEM_APP_NAME,
  //     activeRule: SYSTEM_ACTIVE_RULE,
  //     proPublicPath: SYSTEM_PRO_PUBLIC_PATH,
  //     devPublicPath: SYSTEM_DEV_PUBLIC_PATH,
  //     devPort: SYSTEM_DEV_PORT,
  //   },
  // },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

const loadingStore = useLoadingStore(pinia)
const appStore = useAppStore(pinia)

router.beforeEach((to, from, next) => {
  const tokenStore = useTokenStore(pinia)
  const token = tokenStore.getToken()
  const userStore = useUserStore(pinia)
  if (!token) {
    if (to.path.startsWith(HALL_ACTIVE_RULE)) {
      next()
    } else {
      next({
        path: '/hall',
      })
    }
  } else {
    const reuseTabStore = useReuseTabStore(pinia)
    userStore.logged(token).then(() => {
      next()
      // if (to.path !== '/system/home') {
      //   reuseTabStore.add({
      //     name: '/home',
      //     path: '/system/home',
      //     title: '首页',
      //     closable: false,
      //   })
      // }
    })
  }
})

router.afterEach((to) => {
  const toMeta: IMeta = to.meta || {}

  // 设置背景色
  appStore.setBgColor(toMeta.backgroundColor)

  // 设置标题
  appStore.changeTitle(toMeta.title)

  // 设置loading状态为已完成
  loadingStore.completed()
})

export default router
